import { CommonModule, NgOptimizedImage } from '@angular/common';
import { InAppBrowserPlatform, LeadsType } from '@uc/web/shared/data-models';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CdnPathPipe, AbbreviateButtonTextPipe } from '@uc/utilities';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';
import { RouterModule } from '@angular/router';
import { RequestBtnComponent } from '@uc/web/shared/leads';
import { RequestInfoGAService, UniversityGAService } from '@uc/web/analytics';
import { Product, ProductEnum } from '@uc/shared/data-models';
import { InAppBrowserMessageHandlerService } from '@uc/web/core';
import { getRecommendedUniversitiesSelector } from '../../recommended-unis.utils';
import { fetchRecommendedUniversities } from '../../+state/recommended-universities.actions';

@Component({
	selector: 'uc-leads-success-recommended-unis',
	imports: [
		CdnPathPipe,
		CommonModule,
		NgOptimizedImage,
		RequestBtnComponent,
		AbbreviateButtonTextPipe,
		RouterModule,
	],
	templateUrl: './leads-success-recommended-unis.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadsSuccessRecommendedUnisComponent implements OnInit {
	@Input({ required: true }) leadType!: LeadsType;
	@Input({ required: true }) product!: Product;
	@Input() isInAppBrowser = false;
	@Input() inAppBrowserPlatform: InAppBrowserPlatform = null;
	componentName = 'Success Page Recommended Unis';

	recommendedUnis$ = this._store
		.select(
			getRecommendedUniversitiesSelector(
				this.product,
				this.product === ProductEnum.Clearing,
			),
		)
		.pipe(
			filter((unis) => !!unis),
			map((unis) => {
				if (!unis) return [];
				return unis.slice(0, 2);
			}),
		);

	constructor(
		private _store: Store,
		private _requestInfoGASrv: RequestInfoGAService,
		private _inAppBrowserMessageHandlerSrv: InAppBrowserMessageHandlerService,
		private _uniGTMSrv: UniversityGAService,
	) {}

	ngOnInit(): void {
		this._store.dispatch(fetchRecommendedUniversities());
	}

	onRequestInfoClick(uniId: number, ugSearchOrderPosition: number | null) {
		this._requestInfoGASrv.requestInfoClick(
			this.componentName,
			this.product === ProductEnum.Undergraduate || !this.product
				? ugSearchOrderPosition
				: null,
			this.inAppBrowserPlatform,
		);

		this._inAppBrowserMessageHandlerSrv.ios.onRequestInfo(uniId);
	}

	onUniversityProfileClick(uniId: number, uniName: string, ugso: number | null) {
		this._uniGTMSrv.uniProfileClick(uniId, uniName, ugso, null, this.product);
	}
}
